import { Modifier } from '@popperjs/core';

export const commonPopperModifiers: Partial<Modifier<any, any>>[] = [
  {
    name: 'flip',
    enabled: true,
    options: {
      altBoundary: true,
      rootBoundary: 'viewport',
      padding: 8,
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      tether: true,
      rootBoundary: 'viewport',
      padding: 8,
    },
  },
];
